import axios from 'axios'

// Tasa de cambio {from} -> {to} con caché en localStorage. Reutilizable.
// Solo llama al backend (que a su vez cachea 1h contra Frankfurter/BCE) si NO hay
// tasa cacheada o si tiene ≥1h. Si hay caché fresca, la devuelve sin llamar.
// Idea: precargar al entrar a la página del dashboard para tenerla lista al abrir el tab.

const TTL = 3600000 // 1 hora

async function fetchFromApi (from, to) {
  try {
    const { data } = await axios.get('/api/v2/currency/rate', { params: { from, to } })
    return data.data // { rate, date, from, to }
  } catch (e) {
    return { rate: null, date: null, from, to }
  }
}

/**
 * Devuelve { rate, date } de {from} a {to} (por defecto EUR).
 * rate es null si la divisa no está soportada o el API falla (el llamador cae a manual).
 */
export async function getRate (from = 'USD', to = 'EUR') {
  const key = `epc-fx-${from}-${to}`
  const now = Date.now()

  try {
    const raw = localStorage.getItem(key)
    if (raw) {
      const c = JSON.parse(raw)
      if (c && c.ts && (now - c.ts) < TTL && c.rate != null) {
        return { rate: c.rate, date: c.date || '' } // menos de 1h: sin llamar
      }
    }
  } catch (e) { /* localStorage no disponible: seguimos y llamamos */ }

  const { rate, date } = await fetchFromApi(from, to)
  if (rate != null) {
    try { localStorage.setItem(key, JSON.stringify({ rate, date, ts: now })) } catch (e) { /* ignore */ }
  }
  return { rate, date: date || '' }
}
